const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');

const APIRequest = require('../api_request.js');
const Upsell = require('components/product_show_page/upsell.jsx');
const UrlHelpers = require('components/shared/url_helpers.js');
const { UserStore, Tracker } = require('@reverbdotcom/discovery-ui');

const VIEW_TYPE = 'upsells';
const AID = 'related_content_upsells';


class Upsells extends React.Component {
  constructor() {
    super();

    this.state = {
      loaded: false,
      upsells: [],
    };
  }

  componentDidMount() {
    this.fetchUpsells();
  }

  fetchUpsells() {
    APIRequest.V3.get(
      UrlHelpers.listingUpsellsPath(this.props.listingId),
      { include_grid_images: true },
    ).then((response) => {
      this.setState({ upsells: response.upsells, loaded: true });
      this.trackUpsells(response.upsells);
    });
  }

  trackUpsells(upsells) {
    if (!upsells.length) { return null; }

    Tracker.view({
      name: VIEW_TYPE,
      type: 'listings',
      ids: upsells.map(l => l.id),
    });
  }

  upsells(upsellCollection) {
    const upsells = upsellCollection || this.state.upsells;
    if (upsells.length >= 4) {
      return upsells.slice(0, 4);
    }
    return upsells;
  }

  get hasUpsells() {
    return this.upsells().length;
  }

  get aid() {
    return this.props.aid ? this.props.aid : AID;
  }

  shouldShowTopPick(upsell, index) {
    return index === 0 && upsell.top_pick === true;
  }

  renderPlaceholderItem() {
    return this.props.placeholder;
  }

  renderPlaceholder() {
    return (
      <div className="loading-placeholder-content">
        {this.props.children}
        <div className="placeholder-p quarter-width mb-half " />
        <ul className="card-grid card-grid--4up">
          {this.renderPlaceholderItem()}
          {this.renderPlaceholderItem()}
          {this.renderPlaceholderItem()}
          {this.renderPlaceholderItem()}
        </ul>
      </div>
    );
  }

  renderUpsells() {
    return this.upsells().map((upsell, index) =>
      (<Upsell
        upsell={upsell}
        key={upsell.id}
        aid={this.aid}
        showSidebarUpsell={this.props.showSidebarUpsell}
        showTopPick={this.shouldShowTopPick(upsell, index)}
        addToCartButton={this.props.addToCartButton}
      />));
  }

  render() {
    if (!this.state.loaded) { return this.renderPlaceholder(); }
    if (!this.hasUpsells) { return null; }

    const classes = classNames({ 'card-grid card-grid--4up': !this.props.showSidebarUpsell });

    return (
      <div className={this.props.className}>
        {this.props.children}
        <h4 className="upsells__section-title">
          {I18n.t('productShowPage.recommends')}
        </h4>
        <ul className={classes}>
          {this.renderUpsells()}
        </ul>
      </div>
    );
  }
}

Upsells.propTypes = {
  addToCartButton: PropTypes.any.isRequired,
  listingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  children: PropTypes.node,
  aid: PropTypes.string,
  placeholder: PropTypes.node,
  showSidebarUpsell: PropTypes.bool,
};

Upsells.defaultProps = {
  showSidebarUpsell: false,
};

module.exports = Upsells;



// WEBPACK FOOTER //
// ./javascripts/components/product_show_page/upsells.jsx